import { post } from '@/api/core'
import type { TrackingType } from '@/services/trackingConst'

export namespace tracking {
  export interface TrackingEventPayload {
    /** 埋点类型 */
    type: TrackingType
    /** 渠道信息（UTM query string） */
    channel?: string
  }

  export function trackEvent(payload: TrackingEventPayload) {
    return post('/tracking/event', {}, payload)
  }
}
